const scrollArticles = (Simplebar) => {
    const scrollArticle = document.querySelectorAll(".scroll-articles");
    if (scrollArticle.length > 0) {
        for (var i = 0; i < scrollArticle.length; i++) {
            const simplebarScroll = new Simplebar(scrollArticle[i].querySelector(".scroll-articles__scroll"));
        }
    }
}
export default scrollArticles;
